module.exports = __webpack_public_path__ + "static/media/41-15.c0a58eaa.mp3";